import { ComponentCommonTextEditorWithHtml } from '@/components/DefaultContentTemplate';
import { useChapterStore } from '../../../shared/store/useChapterStore';
import DefaultContentTemplateTextEditor from '@/components/DefaultContentTemplate/TextEditor';

export const Boxes = () => {
  const chapter = useChapterStore((state) => state.chapter);

  if (!chapter) return null;

  return (
    <div className="flex flex-col  gap-4">
      {chapter.chapterContents?.map((content) => {
        if (!content) return null;

        return (
          <div key={content.title} className="rounded-2xl border border-[#9FC3FA] bg-[#F6F9FF] p-5">
            {content.headerIcon && (
              <div className="flex items-center gap-sh-15">
                {content.headerIcon.icon?.url && (
                  <img src={content.headerIcon.icon.url} alt="" className="size-[38px]" />
                )}
                <h3 className="!mb-0 font-cadiz text-sh-28-32 font-bold">{content.title}</h3>
              </div>
            )}
            <DefaultContentTemplateTextEditor
              className="!my-sh-15 font-cadiz !text-sh-16-24"
              component={
                {
                  markdownText: content.content || '',
                } as ComponentCommonTextEditorWithHtml
              }
            />
          </div>
        );
      })}
    </div>
  );
};
